import { useAuth, useUser } from '@clerk/react';

export interface ClerkClientAuth {
  isClerkSignedIn: boolean;
  isClerkLoading: boolean;
  clerkUser: ReturnType<typeof useUser>['user'];
  clerkEmail: string | null;
  clerkUserId: string | null;
  clerkSignOut: (options?: { redirectUrl?: string }) => Promise<void>;
  getClerkToken: () => Promise<string | null>;
}

export function useClerkClientAuth(): ClerkClientAuth {
  const { isSignedIn, isLoaded: isAuthLoaded, signOut, getToken } = useAuth();
  const { user, isLoaded: isUserLoaded } = useUser();

  const isFullyLoaded = isAuthLoaded && isUserLoaded && typeof isSignedIn === 'boolean';

  return {
    isClerkSignedIn: isFullyLoaded && isSignedIn,
    isClerkLoading: !isFullyLoaded,
    clerkUser: user ?? null,
    clerkEmail: user?.primaryEmailAddress?.emailAddress ?? null,
    clerkUserId: user?.id ?? null,
    clerkSignOut: signOut,
    getClerkToken: getToken,
  };
}
